import React from 'react';
import * as S from './styles';

const FlightStep = ({ steps }) => {
  // Protege contra steps undefined ou null
  const safeSteps = steps || [];

  // Se não há steps, renderiza "N/A"
  if (safeSteps.length === 0) {
    return (
      <S.FlightStep>
        <span className='steps-number'>N/A</span>
      </S.FlightStep>
    );
  }

  return (
    <S.FlightStep>
      <span className={`steps-number ${safeSteps.length > 1 && 'colored'}`}>{`${
        safeSteps.length > 1
          ? safeSteps.length - 1 + ` parada${safeSteps.length > 2 ? 's' : ''}`
          : 'DIRETO'
      }`}</span>
      <div className='steps'>
        <div className='ligature' />
        {safeSteps.map((step, index) => (
          <S.Steps key={index}>
            <div className='step' />
          </S.Steps>
        ))}
        <S.Steps>
          <div className='step' />
        </S.Steps>
      </div>
      <S.StepLabel>
        {safeSteps.map((step, index) => (
          <span key={index}>{step?.DepartureStation || ''}</span>
        ))}
        <span>{safeSteps[safeSteps.length - 1]?.ArrivalStation || ''}</span>
      </S.StepLabel>
    </S.FlightStep>
  );
};

export default FlightStep;
